



























import * as JSZip from 'jszip'
import { Component } from 'vue-property-decorator'

import UiButton from '@/components/semantic-ui/Button'
import UiModal from '@/components/semantic-ui/Modal.vue'

import { V1 } from '@/export'

@Component({
	components: {
		UiButton,
		UiModal,
	},
})
export default class ImportModal extends UiModal {

	$refs!: {
		'file-input': HTMLInputElement
	}

	pantryData: V1.Schema | null = null

	async fileInputChanged() {

		const { files } = this.$refs['file-input']

		if (!files || files.length === 0) {
			return
		}

		const file = files[0]

		const zip = await JSZip.loadAsync(file)
		const exportFile = zip.file('export.json')

		if (exportFile) {
			const contents = await exportFile.async('text')
			this.pantryData = JSON.parse(contents) as V1.Schema
		}
		else {
			//console.log('invalid file')
		}
	}

}

